










import type { Ref } from '@vue/composition-api';
import {
  computed,
  onBeforeUnmount,
  watch,
  onMounted,
  defineComponent,
  ref,
} from '@vue/composition-api';
import { EditorContent, Editor as TipTapEditor } from '@tiptap/vue-2';
import {
  BulletListNode,
  HardBreakNode,
  HeadingNode,
  ListItemNode,
  MergeValueNode,
  OrderedListNode,
  ParagraphNode,
  ProsemirrorType,
  TextAlign,
  TextDocNode,
} from '@getaccept/editor-lib';
import Bold from '@tiptap/extension-bold';
import Italic from '@tiptap/extension-italic';
import Link from '@tiptap/extension-link';
import Strike from '@tiptap/extension-strike';
import Superscript from '@tiptap/extension-superscript';
import Text from '@tiptap/extension-text';
import Underline from '@tiptap/extension-underline';
import ExcerptIcon from '../assets/excerpt.svg';
import { t } from '../../helpers/translation.helper';

export default defineComponent({
  components: { ExcerptIcon, EditorContent },
  props: {
    content: {
      type: String,
      required: true,
    },
    isGhost: { type: Boolean },
  },
  setup(props) {
    const editor: Ref<TipTapEditor | null> = ref(null);

    const parsedText = computed(() => JSON.parse(props.content));

    watch(
      () => props.content,
      () => {
        editor.value.commands.setContent(parsedText.value);
      }
    );

    const initEditor = () => {
      editor.value = new TipTapEditor({
        content: parsedText.value,
        editable: false,
        enableInputRules: false,
        enablePasteRules: false,
        extensions: [
          TextDocNode,
          ParagraphNode,
          Text,
          Bold,
          Italic,
          Strike,
          Superscript,
          Underline,
          OrderedListNode,
          BulletListNode,
          ListItemNode,
          MergeValueNode,
          Link.configure({
            autolink: false,
            openOnClick: true,
            linkOnPaste: false,
          }),
          HeadingNode,
          HardBreakNode,
          TextAlign.configure({
            types: [
              ProsemirrorType.Paragraph,
              ProsemirrorType.Heading,
              ProsemirrorType.BulletList,
              ProsemirrorType.OrderedList,
            ],
          }),
        ],
      });
    };

    onMounted(() => {
      initEditor();
    });

    onBeforeUnmount(() => {
      editor.value.destroy();
    });

    return { editor, t };
  },
});
